<div class="modal-header">
    <h4 class="modal-title">Manage Allowed Vendors</h4>
</div>
<div class="modal-body" style="max-height: 70vh; overflow-y: auto">
    <div class="row">
        <div class="col-5">
            <label class="form-label">Available Vendors</label>
            <div class="mb-2">
                <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Search..."
                    [(ngModel)]="availableSearch"
                    (ngModelChange)="filterAvailable()"
                />
            </div>
            <select
                class="form-control"
                size="15"
                style="height: 350px"
                #availableList
                (dblclick)="onAvailableDoubleClick(availableList)"
            >
                @for (vendor of availableVendors; track vendor.id) {
                    <option [value]="vendor.id">{{ vendor.name }}</option>
                }
            </select>
            <small class="text-muted">{{ availableVendors.length }} available</small>
        </div>
        <div class="col-2 d-flex flex-column justify-content-center align-items-center" style="gap: 10px">
            <button
                type="button"
                class="btn btn-sm btn-primary"
                (click)="moveSelectedToRight(availableList)"
                [disabled]="!availableList.value"
                title="Add Selected"
            >
                <fa-icon [icon]="faArrowRight"></fa-icon>
            </button>
            <button
                type="button"
                class="btn btn-sm btn-primary"
                (click)="moveSelectedToLeft(selectedList)"
                [disabled]="!selectedList.value"
                title="Remove Selected"
            >
                <fa-icon [icon]="faArrowLeft"></fa-icon>
            </button>
            <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                (click)="moveAllToSelected()"
                [disabled]="availableVendors.length === 0"
                title="Add All Visible"
            >
                All <fa-icon [icon]="faArrowRight"></fa-icon>
            </button>
            <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                (click)="moveAllToAvailable()"
                [disabled]="selectedVendors.length === 0"
                title="Remove All Visible"
            >
                <fa-icon [icon]="faArrowLeft"></fa-icon> All
            </button>
        </div>
        <div class="col-5">
            <label class="form-label">Selected Vendors</label>
            <div class="mb-2">
                <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Search..."
                    [(ngModel)]="selectedSearch"
                    (ngModelChange)="filterSelected()"
                />
            </div>
            <select
                class="form-control"
                size="15"
                style="height: 350px"
                #selectedList
                (dblclick)="onSelectedDoubleClick(selectedList)"
            >
                @for (vendor of selectedVendors; track vendor.id) {
                    <option [value]="vendor.id">{{ vendor.name }}</option>
                }
            </select>
            <small class="text-muted">{{ selectedVendors.length }} selected</small>
        </div>
    </div>
    <div class="alert alert-info mt-3">
        <small>Double-click a vendor to move it between lists, or use the arrow buttons</small>
    </div>
</div>
<div class="modal-footer">
    <button id="btnSave" type="button" class="btn btn-primary" (click)="save()" [disabled]="isSaving">
        @if (isSaving) {
            <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
        } @else {
            <span>Save</span>
        }
    </button>
    <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
</div>
